import script from "./ChatTopBarNewChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatTopBarNewChat.vue?vue&type=script&setup=true&lang=ts"

import "./ChatTopBarNewChat.vue?vue&type=style&index=0&id=2bbb868c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbb868c"]])

export default __exports__